
//Product media slider

let media_swiper = new Swiper(".product-media-modal__content_sub_slider", {
  spaceBetween: 8,
  slidesPerView: "auto",
  freeMode: true,
  watchSlidesProgress: true,
});

let media_swiper2 = new Swiper(".product-media-modal__content_slider", {
  spaceBetween: 10,
  thumbs: {
    swiper: media_swiper,
  },
});

// Additional synchronization setup
media_swiper2.on('slideChange', function () {
  let activeIndex = media_swiper2.activeIndex;
  media_swiper.slideTo(activeIndex);
});



document.addEventListener("DOMContentLoaded", function() {
  // Get all elements with class "product__modal-opener"
  var modalOpeners = document.querySelectorAll(".product__modal-opener");

  // Function to add class "overflow-hidden" to <html> tag
  function addOverflowHidden() {
    document.documentElement.classList.add("overflow-hidden");
  }

  // Function to remove class "overflow-hidden" from <html> tag
  function removeOverflowHidden() {
    document.documentElement.classList.remove("overflow-hidden");
  }

  // Loop through each "product__modal-opener" element
  modalOpeners.forEach(function(opener) {
    // Add click event listener
    opener.addEventListener("click", function() {
      addOverflowHidden();
    });
  });

  // Get all elements with class "modal-close-button"
  var modalCloseButtons = document.querySelectorAll(".modal-close-button");

  // Loop through each "modal-close-button" element
  modalCloseButtons.forEach(function(button) {
    // Add click event listener
    button.addEventListener("click", function() {
      removeOverflowHidden();
    });
  });
});